import { render, staticRenderFns } from "./SettingsIndividual.vue?vue&type=template&id=eff910b6&scoped=true&"
import script from "./SettingsIndividual.vue?vue&type=script&lang=js&"
export * from "./SettingsIndividual.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIndividual.vue?vue&type=style&index=0&id=eff910b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff910b6",
  null
  
)

export default component.exports